import { Link } from "react-router-dom";

import { getLink, trans } from "~/providers/lang";
import BubbleContact from "~/components/BubbleContact";
import { getSmallPhoto, getFileName } from "~/utils/photo";
import { ROUTES, GALLERY_WEDDING_SMALL_COUNT } from '~/const';
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";
import ArrowRight from "~/components/ArrowRight";

import "./style.less";

export default function WeddingPage() {
	useSeo({
		title: trans("skelet.title.wedding"),
		canonical: "svatebni-saty",
	});

	const imgAlt = `${trans('wedding.alt')}${trans('wedding.preview')}`;
	const pageData = mainStore(state => state.data.pageData);
	const weddingPhotos = pageData.photos.wedding[0];
	const items = Array.from({ length: GALLERY_WEDDING_SMALL_COUNT }).map((item, ind) => ({
		link: `${getLink(ROUTES.galleryWedding)}?strana=1&fotka=${getFileName(weddingPhotos[ind].photo)}`,
		img: getSmallPhoto(weddingPhotos[ind]),
	}));

	return <>
		<div className="body-background">
			<div className="wedding-page top-shadow page-content">
				<h1 className="other-page-title">
					{trans('wedding.title')}
				</h1>
				<div className="row">
					<div className="col-md-6">
						<img src="/img/wedding-1.jpg?2" alt={imgAlt} className="with-border" />
					</div>
					<div className="col-md-6">
						<h2>
							{trans('wedding.title')}
						</h2>
						<p className="desc">
							{trans('wedding.desc')}
						</p>
					</div>
				</div>
				<div className="space-between"></div>
				<div className="row">
					<div className="col-md-6 ourcommodity">
						<ul className="square">
							<li>
								{trans('wedding.option1')}
							</li>
							<li>
								{trans('wedding.option2')}
							</li>
							<li>
								{trans('wedding.option3')}
							</li>
						</ul>
					</div>
					<div className="col-md-6">
						<img src="/img/wedding-2.jpg" alt={imgAlt} className="with-border" />
					</div>
				</div>
				<div className="space-between"></div>
				<div className="gallery top-shadow">
					<h3>
						{trans('home.gallery.title')}
					</h3>
					<div className="gallery-images">
						{ items.map(item => <Link to={item.link} key={item.img}>
							<span className="preview-mini-cover">
								<img src={item.img} />
							</span>
						</Link>) }
						<Link to={getLink(ROUTES.galleryWedding)}>
							<span className="preview-mini-cover last">
								<ArrowRight className="gallery-images-preview" size="small" />
							</span>
						</Link>
					</div>
				</div>
				<div className="body-background">
					<div className="empty-space top-shadow"></div>
					<BubbleContact />
				</div>
			</div>
		</div>
	</>;
}
